import { Component, OnInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ModalcloseReason } from '../../../../node_modules/hsg';

@Component({
  selector: 'app-auth-success-registration',
  templateUrl: './auth-success-registration.component.html',
  styleUrls: ['./auth-success-registration.component.css']
})
export class AuthSuccessRegistrationComponent extends AuthBaseComponent {
  
  submit(){
    let data = this.modalService.data;
    delete data["ProcessSuccess"];
    this.modalService.close(data, ModalcloseReason.action);
  }   
}
